import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

function getSessionId() {
  let sid = localStorage.getItem("kh_sid");
  if (!sid) {
    sid = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("kh_sid", sid);
  }
  return sid;
}

function parseUtm(search) {
  const p = new URLSearchParams(search);
  return {
    utm_source: p.get("utm_source") || undefined,
    utm_medium: p.get("utm_medium") || undefined,
    utm_campaign: p.get("utm_campaign") || undefined,
    utm_term: p.get("utm_term") || undefined,
    utm_content: p.get("utm_content") || undefined,
  };
}

function extractKeyword(referrer) {
  if (!referrer) return undefined;
  try {
    const u = new URL(referrer);
    return u.searchParams.get("q") || u.searchParams.get("query") || undefined;
  } catch {
    return undefined;
  }
}

// Tracks a pageview + time-on-page for every route change. Skips /admin routes.
export function usePageTracker(meta = {}) {
  const location = useLocation();
  const enterRef = useRef(Date.now());

  useEffect(() => {
    if (location.pathname.startsWith("/loginmanage")) return;
    enterRef.current = Date.now();
    const referrer = document.referrer || undefined;
    const payload = {
      session_id: getSessionId(),
      event_type: "pageview",
      path: location.pathname,
      title: document.title,
      referrer,
      search_keyword: extractKeyword(referrer),
      screen: `${window.innerWidth}x${window.innerHeight}`,
      language: navigator.language,
      ...parseUtm(location.search),
      ...meta,
    };
    api.post("/track", payload).catch(() => {});

    const sendTime = () => {
      const spent = Date.now() - enterRef.current;
      if (spent < 800) return;
      const body = {
        session_id: getSessionId(),
        event_type: "engagement",
        path: location.pathname,
        time_spent_ms: spent,
        ...meta,
      };
      try {
        navigator.sendBeacon(
          `${api.defaults.baseURL}/track`,
          new Blob([JSON.stringify(body)], { type: "application/json" })
        );
      } catch {
        api.post("/track", body).catch(() => {});
      }
    };
    window.addEventListener("beforeunload", sendTime);
    return () => {
      sendTime();
      window.removeEventListener("beforeunload", sendTime);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
}
